export default __webpack_public_path__ + "static/modal01_02-pc-383a4e04dbc4b80c48d9162bf14399b9.svg";